<div class="app-container">
    <!-- Sidebar - uniquement pour les pages authentifiées (CAC/CAS) -->
    <app-sidebar *ngIf="!isLandingPage && !isStaticPage && !isLoginPage && isAuthenticated"></app-sidebar>
    
    <!-- Main Content -->
    <div class="main-wrapper" [class.with-sidebar]="!isLandingPage && !isStaticPage && !isLoginPage && isAuthenticated">
        <!-- Navbar - uniquement pour les pages authentifiées (CAC/CAS) -->
        <app-shared-navbar *ngIf="!isLandingPage && !isStaticPage && !isLoginPage && isAuthenticated"></app-shared-navbar>
        
        <div class="content-container">
            <router-outlet></router-outlet>
        </div>
    </div>
    
    <app-session-expired></app-session-expired>
    <p-toast></p-toast>
    
    <!-- Chatbot - uniquement pour les pages authentifiées -->
    <app-chatbot *ngIf="!isLandingPage && !isStaticPage && isAuthenticated"></app-chatbot>
</div>